import { createRouter, createWebHashHistory } from 'vue-router';
import FilterView from '@ProgramList/views/FilterView.vue';
import ResultsView from '@ProgramList/views/ResultsView.vue';

const routes = [
	{ path: '/', component: FilterView }, // filter only view is our default view
	{ path: '/results', component: ResultsView },
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

export default router;
